// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { browserLocalPersistence, initializeAuth } from "firebase/auth";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBROhnB4DGtH9jegyd2UwGjUuB35S0BvOU",
    authDomain: "m-faktor.firebaseapp.com",
    projectId: "m-faktor",
    storageBucket: "m-faktor.firebasestorage.app",
    messagingSenderId: "179218022416",
    appId: "1:179218022416:web:ec44b7ad558263c08bca95"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
//initializeAuth(app)

const auth = initializeAuth(app, {
    persistence: browserLocalPersistence
})
const db = getFirestore();

//const storage = getStorage();

export { app, auth, db, firebaseConfig };